export default __webpack_public_path__ + "static/media/phoneIC.3cb3d95b.svg";